import React, { Fragment, memo, useContext } from "react";
// Provider
import { AppContext } from "../../../components/AppProvider";

// Utils
import { _O } from "../../../modules/utils";

// UI
import styled from "styled-components";
import { getCookie } from "../../../modules/utils/cookie";
import { loginVarify } from "../../../modules/utils/loginAction";

// import _T_PRESCRIPTION from "../../resources/images/sub/prescription_img.jpg";

// TODO - 공통 component로 하게될 경우 작업 필요
export const PersonalInfo = memo((props) => {
  const { modify, handleChange } = props;
  const { userinfo, cfg } = useContext(AppContext);
  //   const modify = props.modify;
  const handleChanged = (e) => {
    handleChange(e);
  };

  const handleButton = () => {
    modify === true ? _O.OpenMenu("/mp/myInfo/view") : _O.OpenMenu("/mp/myInfo/modify");
  };

  // 전화번호 수정 로직
  // 가입채널 000, 500 -> 비밀번호 입력
  // SNS가입 -> 해당 SNS 로그인 로직 -> 비밀번호 입력
  return (
    <div
      className={
        modify === false ? "device-link-contain type3" : "device-link-contain type3 modify"
      }
    >
      {userinfo.userEmail && (
        <div>
          <div className="round-list">
            <div className="title">
              <i className="ic8"></i> 이메일 주소
            </div>
            <div className="tt-input">
              {modify === true ? (
                <input
                  type="text"
                  name="email"
                  value={userinfo.userEmail}
                  onChange={handleChanged}
                />
              ) : (
                <input type="text" name="email" value={userinfo.userEmail} readOnly />
              )}
            </div>
          </div>
        </div>
      )}
      <div>
        <div className="round-list">
          <div className="title">
            <i className="ic9"></i> 이름
          </div>
          <div className="tt-input">
            {modify === true ? (
              <input type="text" name="name" value={userinfo.userName} onChange={handleChanged} />
            ) : (
              <input type="text" name="name" value={userinfo.userName} readOnly />
            )}
          </div>
        </div>
      </div>
      <div>
        <div className="round-list">
          <div>
            <a
              href={void 0}
              className="btn-gray"
              onClick={(e) => loginVarify(getCookie("signUpChannel"))}
            >
              <i className="ic10"></i> 휴대전화
              <u className="ca">수정</u>
            </a>
          </div>
          <div className="tt-input">
            {modify === true ? (
              <input
                type="text"
                name="mobile"
                value={userinfo.userPhone}
                onChange={handleChanged}
              />
            ) : (
              <input type="text" name="mobile" value={userinfo.userPhone} readOnly />
            )}
          </div>
        </div>
      </div>

      <div>
        <div className="round-list">
          <div>
            <a
              href={void 0}
              className="btn-gray"
              onClick={(e) =>
                getCookie("userDI") && getCookie("userDI") != ""
                  ? _O.Open("/membership/acntMerge")
                  : _O.Open("/membership/acntMerge")
              }
            >
              <i className="ic13"></i> 아이디
              {getCookie("userDI") && getCookie("userDI") != "" && <u className="ca">계정통합</u>}
              <u className="ca">계정통합</u>
            </a>
          </div>

          <DataContainerDiv>
            <div
              style={{
                margin: "0px 10px",
                color: "#000",
                fontFamily: "Pretendard",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: "400",
              }}
            >
              {getCookie("userId")}
            </div>
            {getCookie("intgDh") && getCookie("intgDh").length > 0 && (
              <Fragment>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    alignSelf: "stretch",
                    margin: "0px 10px",
                    marginTop: "8px",
                  }}
                >
                  <div
                    style={{
                      color: "#888",
                      fontFamily: "Pretendard",
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: "400",
                    }}
                  >
                    계정통합일
                  </div>
                  <div
                    style={{
                      color: "#000",
                      fontFamily: "Pretendard",
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: "400",
                    }}
                  >
                    {getCookie("intgDh")}
                  </div>
                </div>
              </Fragment>
            )}
          </DataContainerDiv>
        </div>
      </div>

      {getCookie("signUpChannel") === "000" && (
        <div>
          <div className="round-list hauto">
            <div>
              <a href={void 0} className="btn-gray" onClick={(e) => handleButton()}>
                <i className="ic11"></i> 비밀번호 변경
                <u className="ca">{modify === true ? "취소" : "수정"}</u>
              </a>
            </div>
            {modify === true && (
              <div className="tt-input">
                <b className="tit">현재비밀번호</b>
                <div className="tt-input">
                  <input
                    type="password"
                    name="oldPassword"
                    autoComplete="current-password"
                    placeholder="비밀번호를 입력해 주세요."
                    onChange={handleChanged}
                  />
                </div>
              </div>
            )}
            {modify === true && (
              <div className="tt-input">
                <b className="tit">새 비밀번호</b>
                <div className="tt-input">
                  <input
                    type="password"
                    name="newPassword1"
                    placeholder="영어소문자, 숫자 5자 이상"
                    onChange={handleChanged}
                  />
                </div>
              </div>
            )}
            {modify === true && (
              <div className="tt-input">
                <b className="tit">비밀번호 확인</b>
                <div className="tt-input">
                  <input
                    type="password"
                    name="newPassword2"
                    placeholder="영어소문자, 숫자 5자 이상"
                    onChange={handleChanged}
                  />
                </div>
              </div>
            )}
            <div className="tt-input"></div>
          </div>
        </div>
      )}

      {/* 본인인증 */}
      {getCookie("isAuthOk") == "9" && (
        <div>
          <div className="round-list hauto">
            <div>
              <a
                href={void 0}
                className="btn-gray"
                onClick={(e) => _O.OpenMenu("/membership/certification")}
              >
                <i className="ic11"></i> 본인인증
                <u className="ca"></u>
              </a>
            </div>
            <div className="tt-input"></div>
          </div>
        </div>
      )}
    </div>
  );
});

const DataContainerDiv = styled.div`
  display: block;
  width: 100%;
  height: auto !important;
  /* padding: 16px; */
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 8px;
  border: 1px solid #dadada;
  background: #fff;
  padding: 16px 0px;
`;
